import { FormElement } from '@/models/FormElement';
import { Report } from '@/models/ReportElement';
import { Entry } from '@/models/Entry';
import { User } from './User';

interface FormResponse {
    id: number;
    title: string;
    description: string;
    published: boolean;
    elements: any[];
    background: string;
    buttons: string;
    gaTrackingCode: string;
    image: string;
    allowOpenEntry: boolean;
    allowAnonymousEntries: boolean;
    preview: boolean;
    allowRestart: boolean;
    previewCode: string;
    formLabel: any;
    receiveReportByEmail: boolean;
    owner: string;
    user: User;
}

export interface FormRequest {
    id: number | null;
    title: string;
    published: boolean;
    description: string | null;
    owner: string;
    gaTrackingCode: string | null;
    image: string | null;
    background: string | null;
    buttons: string | null;
    allowOpenEntry: boolean;
    allowAnonymousEntries: boolean;
    formLabel: string | null;
    preview: boolean;
    receiveReportByEmail: boolean;
    allowRestart: boolean;
}

export class Form {
    id: number;
    uri: string;
    title: string;
    published: boolean;
    updating: boolean;
    elements: FormElement[] = [];
    description: string;
    background: string;
    buttons: string;
    gaTrackingCode: string;
    image: string | null;
    allowOpenEntry: boolean;
    preview: boolean;
    allowAnonymousEntries: boolean;
    reports: Report[] = [];
    entries: Entry[] = [];
    formLabel: number | null;
    show = false;
    previewCode: string;
    allowRestart: boolean;
    receiveReportByEmail: boolean;
    ownerUri: string;
    owner: User;

    constructor(data: FormResponse) {
        this.id = data.id;
        this.uri = '/api/forms/' + data.id;
        this.title = data.title;
        this.published = data.published;
        this.elements = data.elements.map((el) => {
            return new FormElement({ ...el, form: this.uri });
        });
        this.formLabel = data.formLabel ? data.formLabel.id : null;
        this.description = data.description;
        this.background = data.background;
        this.buttons = data.buttons;
        this.gaTrackingCode = data.gaTrackingCode;
        this.image = data.image;
        this.updating = false;
        this.allowOpenEntry = data.allowOpenEntry;
        this.preview = data.preview;
        this.previewCode = data.previewCode;
        this.allowRestart = data.allowRestart;
        this.allowAnonymousEntries = data.allowAnonymousEntries;
        this.receiveReportByEmail = data.receiveReportByEmail;
        this.ownerUri = data.owner;
        this.owner = data.user;
    }
}

interface FormLabelData {
    id: number;
    title: string;
    hex: string;
}

export class FormLabel {
    id: number;
    title: string;
    hex: string;
    active: boolean;

    constructor(data: any) {
        this.id = data.id;
        this.title = data.title;
        this.hex = data.hex;
        this.active = false;
    }
}

export interface IForm {
    id: number;
    title: string;
    published: boolean;
    updating: boolean;
    elements: FormElement[];
    description: string;
    background: string;
    buttons: string;
    gaTrackingCode: string;
    reports: Report[];
    entries: Entry[];
    ownerUri: string;
    owner: User;
}

export interface IForms {
    [id: number]: IForm;
}
